/* Print Phuket – custom quantity (22 Oct 2026).
   Lets customers type any whole quantity between the smallest and the largest quantity option of a product.
   Price (Method A, approved packs unchanged):
     total(n) = price of the largest pack below n  +  (n - pack) × rate
     rate     = floor((next pack price - pack price) / (next pack qty - pack qty))   [satang, integer maths]
   In the cart this is two linked lines: the real pack variant (qty 1) and "additional pieces" from the
   product's hidden "… – additional pieces" product (one variant per rate). Every amount is a real Shopify variant
   price, so cart, checkout and the order always match the page. Nothing is calculated at checkout.
   Config: product metafields ppk.cq_enabled / ppk.cq_extras (+ optional ppk.cq_min / cq_max / cq_step), rendered by
   snippets/pp-custom-qty.liquid into #pp-cq-cfg. If a rate is missing (prices changed, sync not run) the custom
   option switches itself off for that selection instead of charging a wrong price.
   The two lines are linked by a token (_pp_cq tok / _pp_cq_tok), NOT by Shopify nested lines: the product options
   app's price add-ons (proof, fix artwork, design) swallow nested child lines (tested 22 Oct 2026). */
(function () {
  'use strict';
  if (window.__ppCQ) return; window.__ppCQ = true;
  var cfgEl = document.getElementById('pp-cq-cfg'); if (!cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var S = { on: false, raw: '', n: null, ladder: null, cfgText: '', res: null, root: null, sid: null, lastVid: null, busy: false };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(s) { return (s / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ฿'; }
  function num(name) { var m = String(name).replace(/,/g, '').match(/\d+/); return m ? parseInt(m[0], 10) : 0; }
  var SING = { pcs: 'piece', pieces: 'piece', pads: 'pad', sheets: 'sheet', banners: 'banner', prints: 'print', posters: 'poster', boards: 'board', signs: 'sign', flags: 'flag', labels: 'label' };
  function unitOf(name) { var u = String(name).replace(/^[\d,\s]+/, '').trim(); return u || 'pcs'; }
  function single(u) { return SING[u.toLowerCase()] || u.replace(/s$/, ''); }
  function form() { return $('[id$="__main"] form[action*="/cart/add"]'); }
  function selVid() { var i = form() && form().querySelector('input[name="id"]'); return i ? parseInt(i.value, 10) || null : null; }

  /* ---------- pricing engine (same integer maths as the audit/sync script engine.py) ---------- */
  function quote(lad, n) {
    var qs = lad.map(function (t) { return t.n; });
    var lo0 = qs[0], hi0 = qs[qs.length - 1];
    var mn = Math.max(CFG.min || lo0, lo0), mx = Math.min(CFG.max || hi0, hi0), step = CFG.step > 1 ? CFG.step : 1;
    if (n < mn) return { k: 'min', min: mn };
    if (n > mx) return { k: 'max', max: mx };
    if (n % step) return { k: 'step', step: step };
    if (lad.some(function (t) { return !(t.price > 0) || !t.vid; })) return { k: 'unpriced' };
    var exact = lad.filter(function (t) { return t.n === n; })[0];
    if (exact) return { k: 'ok', n: n, total: exact.price, lo: exact, extra: 0, rate: 0, next: lad[lad.indexOf(exact) + 1] || null };
    var lo = null, hi = null;
    lad.forEach(function (t) { if (t.n < n && (!lo || t.n > lo.n)) lo = t; if (t.n > n && (!hi || t.n < hi.n)) hi = t; });
    var rate = Math.floor((hi.price - lo.price) / (hi.n - lo.n));
    var xv = CFG.rates[String(rate)];
    if (!(rate > 0) || !xv) return { k: 'norate' };
    return { k: 'ok', n: n, total: lo.price + (n - lo.n) * rate, lo: lo, extra: n - lo.n, rate: rate, xvid: xv, next: hi };
  }

  /* ---------- live ladder for the current selection (same endpoint as pp-pdp.js) ---------- */
  var cache = {};
  function loadLadder(vid) {
    var u = CFG.url + '?view=pp&variant=' + vid;
    var p = cache[u] || (cache[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw 0; return r.json(); }));
    return p.then(function (d) {
      var q = d.options[d.options.length - 1];
      if (!q || d.options.length < 2 || !/quantity|qty|pack/i.test(q.name)) return null;
      var lad = q.values.map(function (v) { return { n: num(v.name), name: v.name, vid: v.vid, price: v.price }; })
        .filter(function (t) { return t.n > 0; }).sort(function (a, b) { return a.n - b.n; });
      S.cfgText = d.options.slice(0, -1).map(function (o) { return o.selected; }).join(' · ');
      return lad.length > 1 ? lad : null;
    }).catch(function () { delete cache[u]; return null; });
  }

  /* ---------- UI ---------- */
  var row, panel, input, out;
  function unitLbl() { return S.ladder ? unitOf(S.ladder[S.ladder.length - 1].name) : 'pcs'; } // plural form ("1 banner" / "25 banners")
  function rangeText() {
    if (!S.ladder) return '';
    var lo0 = S.ladder[0].n, hi0 = S.ladder[S.ladder.length - 1].n;
    var mn = Math.max(CFG.min || lo0, lo0), mx = Math.min(CFG.max || hi0, hi0);
    return 'Any number from ' + mn.toLocaleString('en-US') + ' to ' + mx.toLocaleString('en-US') + (CFG.step > 1 ? ', in steps of ' + CFG.step : '');
  }
  function build() {
    row = document.createElement('div');
    row.className = 'pp-cq';
    row.innerHTML =
      '<button type="button" class="pp-tier pp-cq__btn" role="radio" aria-checked="false">' +
        '<span class="pp-tier__q"><i aria-hidden="true"></i>Custom quantity</span><span class="pp-cq__range"></span></button>' +
      '<div class="pp-cq__panel" hidden>' + // no ids: the theme renames ids inside the product form when it re-renders
        '<label class="pp-cq__label"><span>How many do you need?</span>' +
        '<span class="pp-cq__field"><input type="text" inputmode="numeric" autocomplete="off" maxlength="6">' +
        '<span class="pp-cq__unit" aria-hidden="true"></span></span></label>' +
        '<div class="pp-cq__out" aria-live="polite"></div>' +
      '</div>';
    panel = $('.pp-cq__panel', row); input = $('input', row); out = $('.pp-cq__out', row);
    $('.pp-cq__btn', row).addEventListener('click', function () { setOn(true); S.focus = true; input.focus(); });
    input.addEventListener('input', function () {
      var v = input.value, clean = v.replace(/[^\d]/g, '');
      S.raw = v; S.n = /^\s*\d+\s*$/.test(v) ? parseInt(v, 10) : null; S.bad = v.trim() !== '' && S.n === null; S.caret = input.selectionStart;
      update(true);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); S.focus = false; input.blur(); } });
    // the theme repaints the tier list when the pack changes; remember focus so typing is never interrupted
    input.addEventListener('focus', function () { S.focus = true; });
    input.addEventListener('blur', function (e) {
      // a blur right after we switched the pack, with no new focus target, is the theme re-rendering: take focus back
      if ((!e.relatedTarget || (e.relatedTarget.matches && e.relatedTarget.matches('input[type=radio]'))) && Date.now() - (S.selAt || 0) < 2500) { [60, 250, 700].forEach(function (t) { setTimeout(refocus, t); }); return; }
      S.focus = false;
    });
    input.addEventListener('keyup', function () { S.caret = input.selectionStart; });
    out.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pp-cq-pick]'); if (!b) return;
      input.value = b.getAttribute('data-pp-cq-pick'); input.dispatchEvent(new Event('input'));
    });
  }
  function place() { // pp-pdp repaints the tier list on every change: keep our row inside it
    var host = S.root && S.root.querySelector('.pp-tiers'); if (!host) return false;
    var list = $('.pp-tiers__list', host); if (!list) return false;
    if (row.parentNode !== list) {
      list.appendChild(row);
      if (S.focus) { input.focus({ preventScroll: true }); try { input.setSelectionRange(S.caret, S.caret); } catch (e) {} }
    }
    host.classList.toggle('pp-cq-active', S.on);
    return true;
  }
  function refocus() {
    if (!S.focus || !S.on || document.activeElement === input || !input.isConnected) return;
    var a = document.activeElement; // the theme focuses the (hidden) quantity radio after it re-renders: that one we take back
    if (a && a !== document.body && a.matches && a.matches('input:not([type=radio]),textarea,select,button')) return;
    input.focus({ preventScroll: true }); try { input.setSelectionRange(S.caret, S.caret); } catch (e) {}
  }
  function setOn(on) {
    if (S.on === on) return;
    S.on = on; row.classList.toggle('is-on', on); panel.hidden = !on;
    $('.pp-cq__btn', row).setAttribute('aria-checked', on);
    S.root.classList.toggle('pp-cq-on', on);
    place(); update(true);
    if (on) track('pp_cq_open', {});
  }

  function nativeRadio(name) {
    return $$('.pp-native-hidden input[type="radio"]', S.root).filter(function (i) { return i.value === name; })[0] || null;
  }
  function selectTier(t) { // make the theme select the pack variant we build on
    if (!t || selVid() === t.vid) return;
    var r = nativeRadio(t.name); if (!r) return;
    S.selAt = Date.now();
    r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function update(fromInput) {
    if (!S.ladder) { row.hidden = true; return; }
    row.hidden = false;
    $('.pp-cq__range', row).textContent = rangeText();
    $('.pp-cq__unit', row).textContent = unitLbl();
    input.setAttribute('aria-label', 'Custom quantity, ' + rangeText().toLowerCase());
    if (!S.on) { S.res = null; paintPrice(); return; }
    var u = unitLbl(), html = '', res = null;
    if (S.raw.trim() === '') html = '<p class="pp-cq__hint">' + esc(rangeText()) + '.</p>';
    else if (S.bad || S.n === null) html = '<p class="pp-cq__err">Please enter a whole number, for example 37.</p>';
    else {
      res = quote(S.ladder, S.n);
      if (res.k === 'min') html = '<p class="pp-cq__err">The minimum for this option is ' + res.min.toLocaleString('en-US') + ' ' + esc(u) + '.</p>';
      else if (res.k === 'step') html = '<p class="pp-cq__err">Please choose a multiple of ' + res.step + '.</p>';
      else if (res.k === 'max') html = '<p class="pp-cq__err">Online orders go up to ' + res.max.toLocaleString('en-US') + ' ' + esc(u) + '. For ' + S.n.toLocaleString('en-US') + ' ' + esc(u) + ', ask us for a price: we reply within 24 hours on business days.</p>' +
        '<a class="pp-cq__quote" data-pp-cta="custom_qty_quote" href="' + esc(quoteHref(S.n)) + '">Request a quote for ' + S.n.toLocaleString('en-US') + ' ' + esc(u) + ' <span aria-hidden="true">&rarr;</span></a>';
      else if (res.k !== 'ok') html = '<p class="pp-cq__err">This exact quantity isn’t available online for this option. Choose a quantity above or <a href="' + esc(quoteHref(S.n)) + '">request a quote</a>.</p>';
      else {
        var per = res.total / res.n;
        html = '<p class="pp-cq__total"><b>' + money(res.total) + '</b><span>' + money(Math.round(per)) + ' per ' + esc(single(u)) + '</span></p>';
        if (res.extra) html += '<p class="pp-cq__how">' + res.lo.n.toLocaleString('en-US') + ' ' + esc(u) + ' pack + ' + res.extra + ' additional at ' + money(res.rate) + ' each</p>';
        var nx = res.next;
        if (res.extra && nx && nx.price / nx.n < per) {
          var more = nx.price - res.total;
          if (more <= res.total * 0.15) html += '<button type="button" class="pp-cq__up" data-pp-cq-pick="' + nx.n + '">Tip: ' + nx.n.toLocaleString('en-US') + ' ' + esc(u) + ' cost ' + money(nx.price) + ' (' + money(Math.round(nx.price / nx.n)) + ' each), only ' + money(more) + ' more.</button>';
        }
      }
    }
    S.res = res && res.k === 'ok' ? res : null;
    S.state = res ? res.k : (S.raw.trim() === '' ? 'empty' : 'bad');
    out.innerHTML = html;
    input.setAttribute('aria-invalid', S.res || S.raw.trim() === '' ? 'false' : 'true');
    clearTimeout(S.sel);
    if (S.res) { var lo = S.res.lo; if (fromInput) S.sel = setTimeout(function () { selectTier(lo); }, 450); else selectTier(lo); }
    paintPrice();
    if (fromInput && S.res) { clearTimeout(S.tt); S.tt = setTimeout(function () { track('pp_cq_price', { quantity: S.res.n, value: S.res.total / 100 }); }, 1200); }
  }
  function quoteHref(n) {
    var b = '/pages/get-a-quote?type=' + encodeURIComponent(CFG.quoteType || 'marketing') + '&product=' + encodeURIComponent(CFG.title) + '&opts=' + encodeURIComponent(S.cfgText) + '&qty=' + encodeURIComponent(n + ' ' + unitLbl()) + '&from=' + encodeURIComponent(location.pathname);
    return b;
  }

  /* price block + sticky bar while custom quantity is on */
  function paintPrice() {
    var pr = S.sid && document.getElementById('price-' + S.sid);
    var box = pr && pr.querySelector('.pp-cq-price');
    if (S.on && pr) {
      if (!box) { box = document.createElement('div'); box.className = 'pp-cq-price'; pr.appendChild(box); }
      box.innerHTML = S.res
        ? '<span class="pp-cq-price__t">' + money(S.res.total) + '</span><span class="pp-cq-price__u">' + money(Math.round(S.res.total / S.res.n)) + ' per ' + esc(single(unitLbl())) + ' <span>for ' + S.res.n.toLocaleString('en-US') + ' ' + esc(unitLbl()) + '</span></span>'
        : '<span class="pp-cq-price__t pp-cq-price__t--none">Enter a quantity</span><span class="pp-cq-price__u">' + esc(rangeText()) + '</span>';
    } else if (box) box.remove();
    var sp = $('.pp-sticky__p'), st = $('.pp-sticky__t');
    if (S.on && sp) { var want = S.res ? money(S.res.total) : 'Enter a quantity'; if (sp.textContent !== want) sp.textContent = want; }
    if (S.on && st && S.res) { var t2 = S.res.n.toLocaleString('en-US') + ' ' + unitLbl() + ' · ' + S.cfgText.split(' · ').slice(0, 3).join(' · '); if (st.textContent !== t2) st.textContent = t2; }
    var btns = $$('button[name="add"], .pp-sticky__a');
    btns.forEach(function (b) { b.classList.toggle('pp-cq-blocked', S.on && !S.res); });
  }

  /* ---------- add to cart ---------- */
  function problem() {
    if (!S.on) return null;
    if (!S.res) return S.state === 'max' ? 'For this quantity please request a quote (link above), or choose a smaller number.' : 'Please enter a valid quantity first.';
    if (S.busy || selVid() !== S.res.lo.vid) { clearTimeout(S.sel); selectTier(S.res.lo); return 'Updating the price for your quantity, please try again in a second.'; }
    return null;
  }
  window.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('button[name="add"], .product-form__submit, .po-atc-btn, .pp-sticky__a');
    if (!b || !S.on) return;
    var msg = problem(); if (!msg) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var m = $('.pp-cq__err', out) || document.createElement('p'); m.className = 'pp-cq__err'; m.textContent = msg; if (!m.parentNode) out.appendChild(m);
    row.scrollIntoView({ behavior: 'smooth', block: 'center' }); input.focus();
  }, true);

  function labels(r) {
    var u = unitLbl(), tok = 'cq' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    return {
      parent: { 'Total quantity': r.n.toLocaleString('en-US') + ' ' + u + ' (' + r.lo.n.toLocaleString('en-US') + ' pack + ' + r.extra + ' additional)',
                '_pp_cq': JSON.stringify({ tok: tok, n: r.n, pack: r.lo.n, packVid: r.lo.vid, extra: r.extra, rate: r.rate, xvid: r.xvid, max: r.next ? r.next.n - r.lo.n - 1 : 0, total: r.total }) },
      child: { 'For': CFG.title + ' – ' + S.cfgText, 'Total quantity': r.n.toLocaleString('en-US') + ' ' + u, '_pp_own': 'cq', '_pp_cq_tok': tok }
    };
  }
  var prev = window.fetch;
  window.fetch = function (url, opts) {
    try {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      if (S.on && /\/cart\/add(\.js)?(\?|$)/.test(u) && opts && opts.body) {
        if (problem()) return Promise.reject(new Error('pp-cq: invalid custom quantity'));
        var r = S.res;
        if (r.extra > 0) {
          var L = labels(r);
          if (typeof opts.body === 'string') {
            var data = JSON.parse(opts.body);
            if (!data.items) { var one = { id: data.id, quantity: data.quantity || 1, properties: data.properties || {} }; delete data.id; delete data.quantity; delete data.properties; data.items = [one]; }
            var main = null;
            data.items.forEach(function (it) { if (!main && !(it.properties && it.properties._pp_own) && parseInt(it.id, 10) === r.lo.vid) main = it; });
            if (!main) return Promise.reject(new Error('pp-cq: pack line not found'));
            main.quantity = 1; main.properties = Object.assign({}, main.properties || {}, L.parent);
            data.items.splice(data.items.indexOf(main) + 1, 0, { id: r.xvid, quantity: r.extra, properties: L.child });
            opts.body = JSON.stringify(data);
          } else if (opts.body instanceof FormData) {
            var f = opts.body, nf = new FormData(), id = parseInt(f.get('id'), 10);
            if (id !== r.lo.vid) return Promise.reject(new Error('pp-cq: pack line not found'));
            f.forEach(function (v, k) {
              if (k === 'id' || k === 'quantity') return;
              var m = k.match(/^properties\[(.*)\]$/);
              if (m) nf.append('items[0][properties][' + m[1] + ']', v); else nf.append(k, v);
            });
            nf.append('items[0][id]', String(r.lo.vid)); nf.append('items[0][quantity]', '1');
            Object.keys(L.parent).forEach(function (k) { nf.append('items[0][properties][' + k + ']', L.parent[k]); });
            nf.append('items[1][id]', String(r.xvid)); nf.append('items[1][quantity]', String(r.extra));
            Object.keys(L.child).forEach(function (k) { nf.append('items[1][properties][' + k + ']', L.child[k]); });
            opts.body = nf;
          }
          track('pp_cq_add', { quantity: r.n, value: r.total / 100 });
        }
      }
    } catch (e) { return Promise.reject(e); }
    return prev.apply(this, arguments);
  };

  function track(name, p) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name, product: CFG.handle }, p)); if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, p); } catch (e) {} }

  /* ---------- wiring ---------- */
  function refresh() {
    var vid = selVid(); if (!vid || vid === S.lastVid) return;
    S.lastVid = vid; S.busy = true;
    loadLadder(vid).then(function (lad) {
      S.busy = false;
      if (selVid() !== vid) return;
      S.ladder = lad; place(); update(false);
    });
  }
  function start() {
    S.root = $('product-info.pp-pdp'); if (!S.root) return false;
    S.sid = S.root.getAttribute('data-section');
    if (!$('.pp-tiers', S.root)) return false;
    build(); place(); refresh();
    var host = $('.pp-tiers', S.root);
    if ('MutationObserver' in window) {
      new MutationObserver(function () { place(); }).observe(S.root, { childList: true, subtree: true });
      var pr = document.getElementById('price-' + S.sid);
      if (pr) new MutationObserver(function () { if (S.on && !pr.querySelector('.pp-cq-price')) paintPrice(); }).observe(pr, { childList: true, subtree: true });
      var sp = $('.pp-sticky'); if (sp) new MutationObserver(function () { if (S.on) paintPrice(); }).observe(sp, { childList: true, subtree: true, characterData: true });
    }
    // a click on a normal quantity pack leaves custom mode
    S.root.addEventListener('click', function (e) { var t = e.target.closest && e.target.closest('.pp-tier'); if (t && !t.closest('.pp-cq')) setOn(false); }, true);
    setInterval(refresh, 400);
    return true;
  }
  (function wait(n) { if (start()) return; if (n < 80) setTimeout(function () { wait(n + 1); }, 250); })(0);
})();
